import { getApolloClient } from '@/apollo';
import ExtraPayments from '../graphql/ExtraPayments';

function setExtraPayments({ commit }, payload) {
  commit('SET_EXTRA_PAYMENTS', payload.results);
  commit('SET_PAGE_INFO', payload.pageInfo);
}

function setFetchTime({ commit }, payload) {
  commit('SET_LAST_FETCH_TIME', payload);
}

async function fetchExtraPayments(filter, apolloConfig) {
  return getApolloClient().query({
    query: ExtraPayments,
    variables: filter,
    ...apolloConfig,
  });
}

export default {
  fetchExtraPayments: async ({ commit, getters }, filter) => {
    const fetchTime = Date.now();

    let lastFetchTime = getters.getLastFetchTime;
    if (lastFetchTime > fetchTime) {
      return;
    }
    setFetchTime({ commit }, fetchTime);

    commit('SET_PAGE_INFO', {});
    const response = await fetchExtraPayments(filter, { fetchPolicy: 'network-only' });

    lastFetchTime = getters.getLastFetchTime;
    if (fetchTime >= lastFetchTime) {
      setFetchTime({ commit }, fetchTime);
      setExtraPayments({ commit }, response.data.extraPayments);
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/ExtraPayment/store/actions.js